import { Suspense, lazy } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import Layout from "./components/Layout";
import { AppStateProvider } from "./state/AppStateContext";
import ExplorerPage from "./features/explorer/ExplorerPage";

// Cytoscape + the fcose layout plugin are the single heaviest dependency in
// this app and are only ever needed on the Visualize route — lazy-loading
// keeps them out of the initial bundle so landing on the Explorer (the
// default route) doesn't pay for graph-rendering code it isn't using yet.
const VisualizerPage = lazy(() => import("./features/visualizer/VisualizerPage"));

export default function App() {
  return (
    <AppStateProvider>
      <Routes>
        <Route element={<Layout />}>
          <Route index element={<Navigate to="/explore/classes" replace />} />
          <Route path="explore" element={<Navigate to="/explore/classes" replace />} />
          <Route path="explore/:tab" element={<ExplorerPage />} />
          <Route
            path="visualize"
            element={
              <Suspense fallback={<RouteLoadingFallback />}>
                <VisualizerPage />
              </Suspense>
            }
          />
          <Route path="*" element={<Navigate to="/explore/classes" replace />} />
        </Route>
      </Routes>
    </AppStateProvider>
  );
}

function RouteLoadingFallback() {
  return (
    <div className="flex flex-1 items-center justify-center text-sm text-[var(--oe-text-muted)]">
      Loading visualizer…
    </div>
  );
}
